var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.hours_biometric"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalExtraLarge: true,
      "loading-secondary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "biometric-hour-field" } }, [
                _vm._v(_vm._s(_vm.$t("pages.planing-team-validate.hours"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.hourValue,
                    expression: "hourValue",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "biometric-hour-field" },
                domProps: { value: _vm.hourValue },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.hourValue = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("vue-data-table", {
                    attrs: {
                      classTable: _vm.classTable,
                      "table-columns": _vm.columns,
                      "table-rows": _vm.rows,
                      "is-loading": _vm.isLoading,
                      showRefreshButton: false,
                      showRowTableAction: false,
                      showFooterTable: _vm.showFooterTable,
                      "empty-rows-message": _vm.$t("components.table.no_data"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-row",
                        fn: function (props) {
                          return [
                            props.cell.getColumn.id == "name"
                              ? [
                                  _vm._v(
                                    " " + _vm._s(props.cell.getValue) + " "
                                  ),
                                ]
                              : props.cell.getColumn.id ==
                                "biometricHour.biometricType"
                              ? [
                                  props.cell.getValue == 0
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "pages.planing-team.biometric.enter"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.planing-team.biometric.exit"
                                            )
                                          )
                                        ),
                                      ]),
                                ]
                              : _vm._e(),
                            props.cell.getColumn.id ==
                            "biometricHour.biometricDateWithTime"
                              ? [
                                  _c("formatted-date-component", {
                                    staticClass:
                                      "font-weight-light font-weight-italic",
                                    attrs: {
                                      val: props.cell.getValue,
                                      withTime: true,
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "table-tfoot-row",
                        fn: function (props) {
                          return [
                            props.column.id ==
                            "biometricHour.biometricDateWithTime"
                              ? [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col" },
                                      [
                                        _c("formatted-minutes-component", {
                                          attrs: {
                                            val: _vm.biometric.totalMinutes,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "portal-copy-action",
                                          on: { click: _vm.copyHoursToField },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/IC_plan_biometrico_secondary.svg"),
                                              alt: "",
                                              "aria-hidden": "true",
                                            },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.planing-team.biometric.use_this_time"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }